import { TRADE_TERM_APPLY_TO } from "@/static/tradeTermApplyToTypes";
import { ServicePackageItem } from "@/models/api/administration/servicesAndAttributes/ServicePackageItem";

export class ServicePackageSubItem {
  parentServicePackageItemId!: null | string;
  name!: string;
  value!: number;
  serviceTypeId!: null | number;
  isPercentage!: boolean;
  calculatedFrom!: TRADE_TERM_APPLY_TO;
  isHidden!: boolean;
  appliesTo!: TRADE_TERM_APPLY_TO;
  isSeparateItem!: boolean;
  isTradeTerm!: boolean;
  constructor(parentServicePackageItemId: string | null) {
    this.parentServicePackageItemId = parentServicePackageItemId;
    this.name = "";
    this.value = 0;
    this.serviceTypeId = null;
    this.isPercentage = false;
    this.calculatedFrom = TRADE_TERM_APPLY_TO.BaseAndTaxes;
    this.isHidden = false;
    this.appliesTo = TRADE_TERM_APPLY_TO.BaseAndTaxes;
    this.isSeparateItem = false;
    this.isTradeTerm = false;
  }

  static fromServicePackageItem(servicePackageItem: ServicePackageItem): ServicePackageSubItem {
    const servicePackageSubItem = new ServicePackageSubItem(servicePackageItem.parentServicePackageItemId);
    // noinspection DuplicatedCode
    servicePackageSubItem.name = servicePackageItem.name;
    servicePackageSubItem.value = servicePackageItem.amount;
    servicePackageSubItem.serviceTypeId = servicePackageItem.serviceTypeId;
    servicePackageSubItem.isPercentage = servicePackageItem.isPercentage;
    servicePackageSubItem.calculatedFrom = servicePackageItem.percentageCalculateFrom;
    servicePackageSubItem.isHidden = servicePackageItem.isHidden;
    servicePackageSubItem.appliesTo = servicePackageItem.hiddenAppliesTo;
    servicePackageSubItem.isSeparateItem = servicePackageItem.isSeparateItem;
    servicePackageSubItem.isTradeTerm = servicePackageItem.isTradeTerm;
    return servicePackageSubItem;
  }
}
